import { Row, Col, notification } from 'antd'

import React, { useState, useEffect } from 'react'

import styled from 'styled-components'
import ColorList from '../../../constants/color.constants'
import { LeftOutlined } from '@ant-design/icons'

import { Link } from 'react-router-dom'

import AddTaskInformation from './AddTask/Information/addtaskinformation'
import AddTaskAssignee from './AddTask/Assignee/assignee'
import AddTaskSubtask from './AddTask/AddSubtask/addsubtask'
import AddTaskSupportNeed from './AddTask/SupportNeed/supportneed'
import AddTaskKPIFinance from './AddTask/KPIFinance/kpifinance'
import AddTaskChecklist from './AddTask/Checklist/addtaskchecklist'

import '../../../styleLess/signature/addtask.scss'

import { getResultProjectList } from '../../../api/Project/sprintFlow'
//url
import { useParams } from 'react-router-dom'
import { useHistory } from 'react-router-dom'

import { getCookie } from 'helper/cookie'

import lang from 'lang/en'
import Dependencies from './AddTask/Dependencies/dependencies'
const Container = styled.div`
  background-color: ${ColorList.blue1};
  margin-top: -32px;
  margin-left: -32px;
  margin-right: -32px;
  margin-bottom: -32px;
  padding-bottom: 32px;
  width: 100;
  min-height: 798px;
`

const Bodier = styled.div``

const initialState = {
  switchAddTaskComponents: 'addtaskinformation',
  syncFuntion: '',
  nowState: 'information',
  isLoading: true,
}

const AddTask = (props) => {
  const {
    swithCaseTaskFLowFunction,
    rolee,
    idEditPRJ,
    statusProject,
    sendmailStatus,
    canNotEditProject,
    canKPIFinance,
    canSprintTaskFlow,
    memberRole,
    checkDecision,
    checkCanEditProjectByStatus,
    checkPlandateTaskSubTask,
    checkStatusWaiting,
    checkChangeFlow,
    setCheckChangeFlow,
    fullyCheckComplete,
  } = props
  const { funcsetIdChart } = props

  ///lang
  const language = getCookie('lang')
  const word = lang[language]

  const token = getCookie('access_token_admin')

  const [mode, Setmode] = useState(true)
  const [OneUnitFocus, setOneUnitFocus] = useState(1)

  const [isLoading, setIsLoading] = useState(initialState.isLoading)

  const [sprintflowID, setSprintflowID] = useState('dis')

  const [changePageInformation, setChangePageInformation] = useState(true)
  const [changePageInformation2, setChangePageInformation2] = useState(true)
  const [taskStatus, setTaskStatus] = useState('')

  //url
  const history = useHistory()
  const { id } = useParams()
  const [checkLanding, setCheckLanding] = useState(false)

  //nametask
  const [NameTask, setNameTask] = useState()

  const urlPage2 = window.location.href
  const checkLandingPage = () => {
    const urlPage = window.location.href
    const split = urlPage.split('/')
    let landing = ''

    if (canSprintTaskFlow == false) {
      swithCaseTaskFLowFunction('')
      history.push(`/project/${id}/sprintflow`)
    } else {
      if (split[6]) {
        landing = split[6]
        getResultProjectList({
          project_id: parseInt(idEditPRJ),
          id_chart: landing,
          token: token,
        })
          .then(async (response) => {
            const { status, data, error } = response
            if (error) {
              setIsLoading(false)
              return true
            }
            if (status === 200) {
              setTaskStatus(data.flow_status)
              setNameTask(data.title)
              setSprintflowID(data.id)
              if (data.flow_status == 'Done' || data.flow_status == 'Cancel') {
                props.setrolee(true)
              } else {
                props.setrolee(false)
              }
              if (split[7]) {
                landing = split[7]
                if (landing === 'information') {
                  Setmode(true)
                  setOneUnitFocus(1)
                  swithCaseAddTaskFunction('')
                } else if (landing === 'checklist') {
                  Setmode(true)
                  setOneUnitFocus(2)
                  swithCaseAddTaskFunction('checklist')
                } else if (landing === 'assignee') {
                  Setmode(true)
                  setOneUnitFocus(3)
                  swithCaseAddTaskFunction('assignee')
                } else if (landing === 'supportneed') {
                  Setmode(true)
                  setOneUnitFocus(4)
                  swithCaseAddTaskFunction('supportneed')
                } else if (checkDecision == true && landing === 'subtask') {
                  Setmode(true)
                  setOneUnitFocus(1)
                  swithCaseAddTaskFunction('')
                  history.push(`/project/${id}/sprintflow/${funcsetIdChart}/information`)
                } else if (landing === 'subtask') {
                  Setmode(true)
                  setOneUnitFocus(5)
                  swithCaseAddTaskFunction('subTask')
                } else if (landing === 'kpi') {
                  Setmode(true)
                  setOneUnitFocus(6)
                  swithCaseAddTaskFunction('kpifinance')
                } else if (landing === 'dependencies') {
                  Setmode(true)
                  setOneUnitFocus(7)
                  swithCaseAddTaskFunction('dependencies')
                }
                setCheckLanding(true)
              }
            } else {
              setIsLoading(false)
              return true
            }
          })
          .catch((error) => {
            setIsLoading(false)
            console.error(error)
          })
        if (landing !== '') {
          if (checkLanding == false) {
            Setmode(true)
            setOneUnitFocus(1)
            swithCaseAddTaskFunction('')
          }
        }
      }
    }
  }
  useEffect(() => {
    if (checkLanding === false || checkLanding === 'changeURL') {
      checkLandingPage()
    }
  }, [checkLanding])

  useEffect(() => {
    setCheckLanding('changeURL')
  }, [urlPage2])

  const openNotificationWithIcon = (type) => {
    notification[type]({
      message: 'Warning',
      description: 'Please save your information.',
      duration: 3,
    })
  }

  const handleSelect = (check) => {
    if (changePageInformation == false || changePageInformation2 == false) {
      openNotificationWithIcon('warning')
    } else {
      if (check == 1) {
        Setmode(true)
        setOneUnitFocus(1)
        history.push(`/project/${id}/sprintflow/${funcsetIdChart}/information`)
        return swithCaseAddTaskFunction('')
      }
      if (check == 2) {
        if (sprintflowID == 'dis') {
        } else {
          Setmode(true)
          setOneUnitFocus(2)
          history.push(`/project/${id}/sprintflow/${funcsetIdChart}/checklist`)
          return swithCaseAddTaskFunction('checklist')
        }
      }
      if (check == 3) {
        if (sprintflowID == 'dis') {
        } else {
          Setmode(true)
          setOneUnitFocus(3)
          history.push(`/project/${id}/sprintflow/${funcsetIdChart}/assignee`)
          return swithCaseAddTaskFunction('assignee')
        }
      }
      if (check == 4) {
        Setmode(true)
        setOneUnitFocus(4)
        history.push(`/project/${id}/sprintflow/${funcsetIdChart}/supportneed`)
        return swithCaseAddTaskFunction('supportneed')
      }
      if (check == 5) {
        if (sprintflowID == 'dis') {
        } else {
          Setmode(true)
          setOneUnitFocus(5)
          history.push(`/project/${id}/sprintflow/${funcsetIdChart}/subtask`)
          return swithCaseAddTaskFunction('subTask')
        }
      }
      if (check == 6) {
        Setmode(true)
        setOneUnitFocus(6)
        history.push(`/project/${id}/sprintflow/${funcsetIdChart}/kpi`)
        return swithCaseAddTaskFunction('kpifinance')
      }
      if (check == 7) {
        Setmode(true)
        setOneUnitFocus(7)
        history.push(`/project/${id}/sprintflow/${funcsetIdChart}/dependencies`)
        return swithCaseAddTaskFunction('dependencies')
      }
    }
  }

  const [switchAddTaskComponents, setSwitchAddTaskComponents] = useState(
    initialState.switchAddTaskComponents,
  )

  const swithCaseAddTaskFunction = (type) => {
    setSwitchAddTaskComponents(type)
  }

  const renderComponents = (type) => {
    let rolereal = ''
    //rolee คือ status task || canNotEditProject คือ status project
    if (rolee == true || canNotEditProject == true) {
      rolereal = true
    }

    let rolesupportneed = false
    if (rolee == true || canNotEditProject == true) {
      rolesupportneed = true
    }

    switch (switchAddTaskComponents) {
      case 'checklist':
        return (
          <AddTaskChecklist
            id={sprintflowID}
            swithCaseAddTaskFunction={swithCaseAddTaskFunction}
            swithCaseTaskFLowFunction={swithCaseTaskFLowFunction}
            role={rolereal}
            idEditPRJ={idEditPRJ}
          />
        )
      case 'assignee':
        return (
          <AddTaskAssignee
            id={sprintflowID}
            swithCaseAddTaskFunction={swithCaseAddTaskFunction}
            swithCaseTaskFLowFunction={swithCaseTaskFLowFunction}
            role={rolereal}
            idEditPRJ={idEditPRJ}
          />
        )
      case 'supportneed':
        return (
          <AddTaskSupportNeed
            id={sprintflowID}
            memberRole={memberRole}
            swithCaseAddTaskFunction={swithCaseAddTaskFunction}
            swithCaseTaskFLowFunction={swithCaseTaskFLowFunction}
            role={rolesupportneed}
            idEditPRJ={idEditPRJ}
            sendmailStatus={sendmailStatus}
            checkStatusWaiting={checkStatusWaiting}
          />
        )
      case 'kpifinance':
        return (
          <AddTaskKPIFinance
            canKPIFinance={canKPIFinance}
            id={sprintflowID}
            swithCaseAddTaskFunction={swithCaseAddTaskFunction}
            swithCaseTaskFLowFunction={swithCaseTaskFLowFunction}
            role={rolereal}
            idEditPRJ={idEditPRJ}
            statusProject={statusProject}
          />
        )
      case 'subTask':
        return (
          <AddTaskSubtask
            canKPIFinance={canKPIFinance}
            memberRole={memberRole}
            roleold={rolereal}
            id={sprintflowID}
            funcsetIdChart={funcsetIdChart}
            swithCaseAddTaskFunction={swithCaseAddTaskFunction}
            swithCaseTaskFLowFunction={swithCaseTaskFLowFunction}
            role={rolee}
            idEditPRJ={idEditPRJ}
            statusProject={statusProject}
            checkCanEditProjectByStatus={checkCanEditProjectByStatus}
            checkPlandateTaskSubTask={checkPlandateTaskSubTask}
            checkStatusWaiting={checkStatusWaiting}
            checkChangeFlow={checkChangeFlow}
            setCheckChangeFlow={setCheckChangeFlow}
            fullyCheckComplete={fullyCheckComplete}
          />
        )
      case 'dependencies':
        return (
          <Dependencies
            sprintflowId={sprintflowID}
            projectId={idEditPRJ}
            taskStatus={taskStatus}
          />
        )
      default:
        return (
          <AddTaskInformation
            swithCaseAddTaskFunction={swithCaseAddTaskFunction}
            swithCaseTaskFLowFunction={swithCaseTaskFLowFunction}
            funcsetIdChart={funcsetIdChart}
            setSprintflowID={setSprintflowID}
            role={rolereal}
            idEditPRJ={idEditPRJ}
            setChangePageInformation={setChangePageInformation}
            setChangePageInformation2={setChangePageInformation2}
            GetName={GetName}
            checkDecision={checkDecision}
            checkPlandateTaskSubTask={checkPlandateTaskSubTask}
            checkChangeFlow={checkChangeFlow}
            setCheckChangeFlow={setCheckChangeFlow}
            fullyCheckComplete={fullyCheckComplete}
          />
        )
    }
  }

  useEffect(() => {
    if (sprintflowID != 'dis') {
      renderComponents()
    }
  }, [switchAddTaskComponents, sprintflowID])

  const onClickBack = () => {
    swithCaseTaskFLowFunction('')
    history.push(`/project/${id}/sprintflow`)
  }

  const FunctioncheckDecision = (checkDecision2) => {
    if (checkDecision2 == true) {
    } else {
      return (
        <div
          className={mode && OneUnitFocus == 5 ? 'Tabbar' : 'active-Tabbar'}
          onClick={() => handleSelect(5)}
        >
          <h3>{word['addtask_tab_subtask']}</h3>
        </div>
      )
    }
  }

  const GetName = () => {
    if (funcsetIdChart) {
      getResultProjectList({
        project_id: parseInt(idEditPRJ),
        id_chart: funcsetIdChart,
        token: token,
      })
        .then(async (response) => {
          const { status, data, error } = response

          if (error) {
            setIsLoading(false)
            return true
          }
          if (status === 200) {
            setNameTask(data.title)
            setIsLoading(false)
          } else {
            setIsLoading(false)
            return true
          }
        })
        .catch((error) => {
          setIsLoading(false)
          console.error(error)
        })
    }
  }

  useEffect(() => {
    if (token) {
      GetName()
    }
  }, [token])

  return (
    <Container className="Body" style={{ borderRadius: '0px 8px 8px 0px' }}>
      <Link id="BacktoSprint(Task)Flow" onClick={() => onClickBack()}>
        <LeftOutlined
          style={{ marginTop: 16, marginLeft: 32, marginRight: 10, color: '#127ec3' }}
        />
        {word['addtask_link_backtosprinttask']}
      </Link>
      <Row>
        <Col span={24}>
          <div
            id="divBackGroundWhite"
            style={{
              marginTop: 16,
              marginLeft: 32,
              marginRight: 32,
              padding: 32,
              backgroundColor: ColorList.white,
              minHeight: 900,
              borderRadius: '8px',
            }}
          >
            <Row>
              <h2>
                {word['addtask_title_keyaction']} : {props.code}
              </h2>
              <h2 className="clutter" style={{ marginLeft: '8px' }}>
                {NameTask}
              </h2>
            </Row>

            <Bodier className="Bodier2">
              <div className="tab">
                <div
                  id="Information"
                  className={mode && OneUnitFocus == 1 ? 'Tabbar' : 'active-Tabbar'}
                  onClick={() => handleSelect(1)}
                >
                  <h3>{word['addtask_tab_information']}</h3>
                </div>
                <div
                  id="Assignee"
                  className={mode && OneUnitFocus == 3 ? 'Tabbar' : 'active-Tabbar'}
                  onClick={() => handleSelect(3)}
                >
                  <h3>{word['addtask_tab_assignee']}</h3>
                </div>
                <div
                  id="KPI"
                  className={mode && OneUnitFocus == 6 ? 'Tabbar' : 'active-Tabbar'}
                  onClick={() => handleSelect(6)}
                >
                  <h3>{word['addtask_tab_kpi']}</h3>
                </div>
                <div
                  id="CheckList"
                  className={mode && OneUnitFocus == 2 ? 'Tabbar' : 'active-Tabbar'}
                  onClick={() => handleSelect(2)}
                >
                  <h3>{word['addtask_tab_checklist']}</h3>
                </div>
                <div
                  id="SupportNeed"
                  className={mode && OneUnitFocus == 4 ? 'Tabbar' : 'active-Tabbar'}
                  onClick={() => handleSelect(4)}
                >
                  <h3>{word['addtask_tab_supportneed']}</h3>
                </div>
                <div
                  id="Dependencies"
                  className={mode && OneUnitFocus == 7 ? 'Tabbar' : 'active-Tabbar'}
                  onClick={() => handleSelect(7)}
                >
                  <h3>Dependencies</h3>
                </div>
                {FunctioncheckDecision(checkDecision)}
              </div>
            </Bodier>

            {renderComponents()}
          </div>
        </Col>
      </Row>
    </Container>
  )
}

export default AddTask
